import { White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: '64px',
  height: '719px'
});

export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '24px'
});
export const title = css({
  color: White.White10,
  fontSize: '40px'
});
export const description = css({
  color: White.White10Alpha70,
  fontSize: '32px'
});

export const bottomContainer = css({
  width: '320px'
});
